import homeImage1 from '../images/home/10.jpg';
import homeImage2 from '../images/home/30.jpeg';
import homeImage3 from '../images/home/40.jpg';
import homeImage4 from '../images/home/50.jpeg';
import homeImage5 from '../images/home/60.jpg';
import homeImage6 from '../images/home/70.jpg';
import homeImage7 from '../images/home/75.JPG';
import homeImage8 from '../images/home/80.JPG';
import homeImage9 from '../images/home/85.jpg';

export const homeGalleryImages = [
  {
    id: 1,
    src: homeImage1,
    alt: 'Villa Mandragora — home gallery image 1',
  },
  {
    id: 2,
    src: homeImage2,
    alt: 'Villa Mandragora — home gallery image 2',
  },
  {
    id: 3,
    src: homeImage3,
    alt: 'Villa Mandragora — home gallery image 3',
  },
  {
    id: 4,
    src: homeImage4,
    alt: 'Villa Mandragora — home gallery image 4',
  },
  {
    id: 5,
    src: homeImage5,
    alt: 'Villa Mandragora — home gallery image 5',
  },
  {
    id: 6,
    src: homeImage6,
    alt: 'Villa Mandragora — home gallery image 6',
  },
  {
    id: 7,
    src: homeImage7,
    alt: 'Villa Mandragora — home gallery image 7',
  },
  {
    id: 8,
    src: homeImage8,
    alt: 'Villa Mandragora — home gallery image 8',
  },
  {
    id: 9,
    src: homeImage9,
    alt: 'Villa Mandragora — home gallery image 9',
  },
];

export const overviewImages = {
  hero: homeGalleryImages[0],
  villa: homeGalleryImages[1],
  pool: homeGalleryImages[2],
  location: homeGalleryImages[3],
  bay: homeGalleryImages[4],
  detail: homeGalleryImages[5],
};
